__turbopack_context__.v({
  "cardCaption": "rich-bio-module__egc_4a__cardCaption",
  "collection": "rich-bio-module__egc_4a__collection",
  "collectionHeading": "rich-bio-module__egc_4a__collectionHeading",
  "description": "rich-bio-module__egc_4a__description",
  "drawerHead": "rich-bio-module__egc_4a__drawerHead",
  "error": "rich-bio-module__egc_4a__error",
  "expandable": "rich-bio-module__egc_4a__expandable",
  "expanded": "rich-bio-module__egc_4a__expanded",
  "form": "rich-bio-module__egc_4a__form",
  "glyph": "rich-bio-module__egc_4a__glyph",
  "grid": "rich-bio-module__egc_4a__grid",
  "largeCaption": "rich-bio-module__egc_4a__largeCaption",
  "largeCard": "rich-bio-module__egc_4a__largeCard",
  "message": "rich-bio-module__egc_4a__message",
  "messageIcon": "rich-bio-module__egc_4a__messageIcon",
  "more": "rich-bio-module__egc_4a__more",
  "photo": "rich-bio-module__egc_4a__photo",
  "privacy": "rich-bio-module__egc_4a__privacy",
  "search": "rich-bio-module__egc_4a__search",
  "send": "rich-bio-module__egc_4a__send",
  "sent": "rich-bio-module__egc_4a__sent",
  "tile": "rich-bio-module__egc_4a__tile",
  "video": "rich-bio-module__egc_4a__video",
  "visit": "rich-bio-module__egc_4a__visit",
});
